import React, {Component} from "react";
import classNames from "classnames";
import styles from "../view/stockVideo/video/FJVideoMedias.module.less";
import {connect} from 'react-redux';
import FJMediaCollectionView from "../view/stockVideo/FJMediaCollectionView";
import FJVideoSearchView from "../view/stockVideo/video/FJVideoSearchView";
import {FJStockVideoAction} from "../../../redux/action/FJRoot.action";
import FJUtil from "../../../util/FJUtil";
import FJSearch from "../view/stockVideo/search/FJSearch";
import FJViewConstant from '../../../constant/FJViewConstant'
import FJConfig from "../../../config/FJConfig";
import FJMedia from "../../../store/FJMedia";
import FJCoreConstant from "../../../core/constant/FJCoreConstant";
import FJLocalStore from "../../../store/FJLocalStore";

class FJVideoMediasContainer extends Component{

	constructor(props) {
		super(props);
		const random = FJUtil.random;
		this.videoCollections = this._handelCollection([
      {
        url: 'business.jpg',
        name: 'business',
        keywords: random(['marketing', 'office', 'work', "success", "meeting", "company", "team", "shop", "sales"], 3)
      },
      {url: 'background.jpg', name: 'background', keywords: random(['4k', 'intro', 'digital', "end"], 3)},
      {url: 'birthday.jpg', name: 'birthday', keywords: random(['party', 'celebration', 'gift', "fireworks"], 3)},
      {url: 'wedding.jpg', name: 'wedding', keywords: random(['love', 'couple', 'valentine', "marriage"], 3)},
      {url: 'abstract.jpg', name: 'abstract', keywords: random(['fire', 'light', 'beautiful'], 3)},
      {url: 'holiday.jpg', name: 'holiday', keywords: random(['Christmas', 'new year', 'Halloween'], 3)},
      {url: 'finance.jpg', name: 'finance', keywords: random(['money', 'cash', 'insurance'], 3)},
      {url: 'emotion.jpg', name: 'emotion', keywords: random(['happy', 'sad', 'smile', 'alone'], 3)},
      {
        url: 'travel.jpg',
        name: 'travel',
        keywords: random(['beach', 'world', 'hotel', 'city', 'dubai', 'adventure', 'africa'], 3)
      },
      {url: 'food.jpg', name: 'food', keywords: random(['coffee', 'restaurant', 'cake', 'kitchen', 'pizza'], 3)},
      {url: 'animation.jpg', name: 'animation', keywords: random(['3d', 'cartoon'], 2)},
      {url: 'family.jpg', name: 'family', keywords: random(['friends', 'thanks', 'home'], 3)},
      {url: 'people.jpg', name: 'people', keywords: random(['woman', 'baby', 'kids', 'children', 'adult', 'girl'], 3)},
      {
        url: 'technology.jpg',
        name: 'technology',
        keywords: random(['computer', 'phone', 'website', 'laptop', 'internet', 'data', 'mobile', 'online', 'search'], 3)
      },
      {url: 'music.jpg', name: 'music', keywords: random(['dj', 'guitar', 'website', 'sing'], 3)},
      {
        url: 'nature.jpg',
        name: 'nature',
        keywords: random(['water', 'earth', 'flowers', 'sea', 'forest', 'sky', 'rain', 'snow', 'pollution', 'summer', 'aerial', 'space'], 3)
      },
      {url: 'fashion.jpg', name: 'fashion', keywords: random(['beauty', 'shopping', 'hair', 'makeup'], 3)},
      {
        url: 'education.jpg',
        name: 'education',
        keywords: random(['school', 'book', 'study', 'student', 'question', 'teacher', 'thinking'], 3)
      },
      {
        url: 'social.jpg',
        name: 'social',
        keywords: random(['facebook', 'youtube', 'instagram', 'social media', 'subscribe', 'contact', 'call', 'like', 'news', 'email'], 3)
      },
      {
        url: 'real-estate.jpg',
        name: 'real-estate',
        keywords: random(['house', 'building', 'construction', 'apartment'], 3)
      },
      {url: 'animal.jpg', name: 'animal', keywords: random(['dog', 'cat', 'fish', 'apartment'], 3)},
      {url: 'health.jpg', name: 'health', keywords: random(['doctor', 'help', 'heart', 'dentist'], 3)},
      {url: 'delivery.jpg', name: 'delivery', keywords: random(['airplane', 'plane', 'car', 'auto'], 3)},
      {url: 'art.jpg', name: 'art', keywords: random(['design', 'dance', 'movie'], 3)},
      {
        url: 'sport.jpg',
        name: 'sport',
        keywords: random(['soccer', 'football', 'fitness', 'basketball', 'gym', 'training', 'run', 'yoga'], 3)
      },
      {
        url: 'life.jpg',
        name: 'life',
        keywords: random(['massage', 'tv', 'future', 'countdown', 'market', 'spa', 'time'], 3)
      },
      {url: 'color.jpg', name: 'color', keywords: random(['blue', 'white', 'black'], 3)},
    ]);
		this._inputValueWithChange = '';
	}

  _handelCollection = (videoCollections) => {
    videoCollections.forEach(item => {
      item.cover = FJConfig.stockVideoResource + item.url
    })
    return videoCollections;
  }

	_onSearch = (value) => {
	  const {sortType} = this.props;
	  const {onSearchVideo} = this.props;
	  onSearchVideo(value, sortType, 1);
  };

	_collectionSearch = (value, localName) => {
		this._onSearch(localName.toLowerCase());
	};

	_onNextPage = () => {
    const {sortType, page, keywords, searchMode, total} = this.props;
    const {onSearchVideo} = this.props;
		if (total && searchMode === FJViewConstant.STOCK_SEARCH_SUCCESS) {
			onSearchVideo(keywords, sortType, page + 1);
		}
  };

	_onSortChange = (sortType) => {
    const {onSearchVideo} = this.props;
    onSearchVideo(this._inputValueWithChange, sortType, 1);
  };

	_onRetry = () => {
		const {sortType, page, keywords} = this.props;
		const {onSearchVideo} = this.props;
		onSearchVideo(keywords, sortType, page);
	};

  _onChange = (value) => {
    this._inputValueWithChange = value;
    if (value === '') {
      this.props.onClear();
    }
  };

  _onSubmit = (id, preSelected, url, options) => {
      // 做埋点统计
      if (!preSelected) {
          FJUtil.ealog(
              'add stock media',
              {
                  'media type': 'video',
                  'keywords': this.props.keywords,
                  editor: 'timeline'
              });
      }
    this.props.toggleStockMedia(id, FJCoreConstant.VIDEO, FJMedia.MediaFromType().STOCK, !preSelected, url, options)
  };

	render() {
		const {onClear, onPreview, onClearHistory} = this.props;
		const {active, total, sortType, keywords, mediaList, searchVideos, history, searchMode, videoPanelType} = this.props;
    const slectedIds = mediaList
      .filter(media => searchVideos.find(image => image.id === media.id))
      .map(media => media.id);

		return (
			<div className={classNames(styles.video_container, {[styles.active]: active})}>
        <FJSearch onSortChange={this._onSortChange}
                  placeHolder={FJLocalStore._('search-video')}
                  videoStyle
                  onSubmit={this._onSearch}
                  onChange={this._onChange}
                  onClear={onClear}
                  onClearHistory={onClearHistory}
                  value={keywords}
                  history={history}
                  sortType={sortType}
                  couldSort
        />
				<FJMediaCollectionView collections={this.videoCollections}
				                       hasShadow
															 active={active && videoPanelType === 1}
															 onSearch={this._collectionSearch}
				/>
				<FJVideoSearchView active={active && videoPanelType === 2}
				                   onRetry={this._onRetry}
				                   searchStatus={FJUtil.getStatusWithStockSearch(searchMode, total, searchVideos.length)}
				                   collections={searchVideos}
                           slectedIds={slectedIds}
                           onPreview={onPreview}
                           onSubmit={this._onSubmit}
													 keywords={keywords}
													 total={total}
													 onSearch={this._onSearch}
													 searchKeyword={keywords}
													 searchNextPage={this._onNextPage}
				/>
			</div>
		)
	}
}

const mapStateToProps = function (state) {
	return {
    mediaList: state.media.mediaList,
    searchVideos: state.stock.searchVideos,
    keywords: state.stock.searchVideoKeyword,
    sortType: state.stock.searchVideoSortType,
    history: state.stock.searchVideoHistory,
    searchMode: state.stock.searchVideoMode,
    total: state.stock.searchVideoTotal,
    page: state.stock.searchVideoPage,
    videoPanelType: state.stock.videoPanelType,
	}
}

const mapDispatchToProps = function (dispatch) {
	return {
		onPreview: function (data) {
			dispatch(FJStockVideoAction.setStockDetailModalAction(data))
		},
    onSearchVideo: function (keywords, sortType, page) {
		  dispatch(FJStockVideoAction.searchVideoAction(keywords, sortType, page))
    },
    toggleStockMedia: function (id, type, fromType, toggle, url, options) {
      dispatch(FJStockVideoAction.toggleStockMediaAction(id, type, fromType, toggle, url, options))
    },
    onClearHistory: function () {
			dispatch(FJStockVideoAction.deleteVideoHistoryAction(FJViewConstant.SEARCH_STOCK_VIDEO))
    },
    onClear: function () {
		  dispatch(FJStockVideoAction.clearVideoSearchAction());
    },
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(FJVideoMediasContainer);
